import { render, staticRenderFns } from "./sentenceM1.vue?vue&type=template&id=d5e0f320&scoped=true&"
import script from "./sentenceM1.vue?vue&type=script&lang=js&"
export * from "./sentenceM1.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM1.vue?vue&type=style&index=0&id=d5e0f320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e0f320",
  null
  
)

export default component.exports